// AUTO-GENERATED from design/handoff/help-data.js — the portal ticket fixture.
// Phase-4 client-side data, shaped like the future authed ticket API (API_MAP.md:
// "the helpdesk is the TRIBUS/support build"). The portal reuses the v1 ticket
// store; the real read/write swap lands with the Displet auth boundary (final v3
// step). Do not hand-edit; regenerate from help-data.js.
/* eslint-disable */

export type TicketTone = "amber" | "blue" | "green" | "gray";
export interface PortalTicket {
  id: string;
  subject: string;
  status: string;
  statusTone: TicketTone;
  updated: string;
  opened: string;
  owner: string;
  brand: string;
  space: string;
  thread: [string, string, string][]; // [who("you"|"staff"), body, when]
}

export const TICKETS = [{"id":"SUP-4821","subject":"Feed to Zillow stopped after we changed row governance","status":"In progress","statusTone":"amber","updated":"2 hours ago","opened":"Sep 9, 2026","owner":"Ada Reyes","brand":"recursive","space":"Coastal Carolinas MLS","thread":[["you","We narrowed the row filter on the Broker IDX feed yesterday afternoon and the Zillow sync has not run since. Nothing in our own logs.","Sep 9, 4:12 PM"],["staff","Thanks — I can see the feed. The filter change queued a re-index and the consumer is waiting on it. The re-index is 82% through and should release the sync within the hour. Nothing is lost; records will backfill in one pass.","Sep 9, 5:38 PM"],["you","Understood. Will it count as a full refresh on their side?","Sep 10, 8:02 AM"],["staff","It will arrive as a delta, not a full refresh, so their listing counts will not spike. I will confirm here once the sync completes.","Sep 10, 8:20 AM"]]},{"id":"SUP-4790","subject":"Two agents cannot sign in after we renamed a group in our directory","status":"Waiting on you","statusTone":"blue","updated":"Yesterday","opened":"Sep 7, 2026","owner":"Marcus Bell","brand":"solidearth","space":"Coastal Carolinas MLS","thread":[]},{"id":"SUP-4712","subject":"Commission plan change did not prorate the cap","status":"Solved","statusTone":"green","updated":"Aug 30, 2026","opened":"Aug 28, 2026","owner":"Priya Nair","brand":"nautilent","space":"Harbor & Pine Realty","thread":[]},{"id":"SUP-4655","subject":"Request: add lot size in square feet to the appraisal feed","status":"Solved","statusTone":"green","updated":"Aug 21, 2026","opened":"Aug 19, 2026","owner":"Ada Reyes","brand":"recursive","space":"Coastal Carolinas MLS","thread":[]},{"id":"SUP-4834","subject":"Hotsheet emails arriving at 6am instead of 7am","status":"In progress","statusTone":"amber","updated":"5 hours ago","opened":"Sep 9, 2026","owner":"Marcus Bell","brand":"solidearth","space":"Coastal Carolinas MLS","thread":[]},{"id":"SUP-4828","subject":"Roster sync dropped 14 agents after our office merge","status":"In progress","statusTone":"amber","updated":"3 hours ago","opened":"Sep 9, 2026","owner":"Priya Nair","brand":"nautilent","space":"Harbor & Pine Realty","thread":[]},{"id":"SUP-4801","subject":"Which checklist items block a closing?","status":"Waiting on you","statusTone":"blue","updated":"Yesterday","opened":"Sep 8, 2026","owner":"Priya Nair","brand":"nautilent","space":"Harbor & Pine Realty","thread":[]}] as PortalTicket[];

// Categories offered on the submit form, per brand (from the brand help topics).
export const TICKET_TOPICS: Record<string, string[]> = {
  recursive: ["Listing add/edit", "Data distribution", "RESO & compliance", "Roles & permissions", "Reports & analytics", "Something else"],
  solidearth: ["Member search", "SSO & identity", "Association websites", "Displet IDX", "Member communications", "Something else"],
  nautilent: ["Transactions", "Commissions & plans", "Recruiting & onboarding", "Offices & rosters", "Accounting exports", "Integrations", "Something else"],
};

// Tickets created this session (the mock write path). Kept in a module store so a
// submitted ticket actually appears in "My tickets" and its thread opens — the
// real path writes to the authed ticket API (final v3 step). Prepended so the
// newest shows first.
const created: PortalTicket[] = [];

export function allTickets(): PortalTicket[] {
  return [...created, ...TICKETS];
}

export function isOpenStatus(status: string): boolean {
  return status !== "Solved" && status !== "Closed";
}

export function openTicketCount(brandId: string): number {
  return allTickets().filter((t) => t.brand === brandId && isOpenStatus(t.status)).length;
}

/** Find a ticket scoped to the brand — a detail URL must not read another brand's ticket. */
export function findTicket(id: string, brandId: string): PortalTicket | undefined {
  return allTickets().find((t) => t.id === id && t.brand === brandId);
}

// Replies added this session, keyed by ticket id — kept in the store (not
// component state) so a sent reply survives leaving and reopening the ticket.
const replies: Record<string, [string, string, string][]> = {};

/** The full thread for a ticket: its base thread plus any session replies. */
export function threadFor(t: PortalTicket): [string, string, string][] {
  return [...t.thread, ...(replies[t.id] ?? [])];
}

/** Append a reply to a ticket (mock write path). Persists in the session store. */
export function addReply(id: string, body: string): void {
  (replies[id] ??= []).push(["you", body, "Just now"]);
}

let seq = 0;
/** Create a ticket with a non-colliding id and store it so the list/thread reflect it. */
export function createTicket(input: { brand: string; space: string; subject: string; detail: string; owner?: string }): PortalTicket {
  // Ids above the fixture range (which is SUP-48xx/49xx), so no collision.
  const id = `SUP-9${String(1 + seq++).padStart(3, "0")}`;
  const t: PortalTicket = {
    id,
    subject: input.subject,
    status: "Waiting on us",
    statusTone: "blue",
    updated: "just now",
    opened: "Just now",
    owner: input.owner ?? "Support",
    brand: input.brand,
    space: input.space,
    thread: [["you", input.detail, "Just now"]],
  };
  created.unshift(t);
  return t;
}
